// extracted by mini-css-extract-plugin
export default {"title":"newin_title__gNwgg","container":"newin_container__kDsEu","btn":"newin_btn__Fj13C"};